/**
 * Created by dorozco on 06/05/2019.
 */

import {Injectable} from '@angular/core';
import {
  IResourceMethod, Resource,
  ResourceAction,
  ResourceHandler,
  ResourceParams,
  ResourceRequestMethod
} from '@ngx-resource/core';
import {TramitesModel} from './tramites.model';
import {CategoriaModel} from '../../admin.categorias.module/service/categoria';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class TramitesResource extends ResourceAuth {
  constructor(restHandler: ResourceHandler, authProv: AuthServerProvider) {
    super(restHandler, authProv);
  }

  //export class TramitesResource extends Resource {
  // constructor(restHandler: ResourceHandler) {
  //  super(restHandler);
  // }

  @ResourceAction({
    path: '/lista_tramites/{!tipo}'
  })
  obtenerListaTramites: IResourceMethod<{ tipo: string }, TramitesModel[]>;

  @ResourceAction({
    path: '/tramites',
    method: ResourceRequestMethod.Get,
    isArray: true,
  })
  listaTramites: IResourceMethod<any, TramitesModel[]>;

  @ResourceAction({
    path: '/lista_tramites/activos'
  })
  obtenerListaTramitesActivos: IResourceMethod<any, TramitesModel[]>;

  @ResourceAction({
    path: '/lista_tramites/rc_activos'
  })
  obtenerListaTramitesRCActivos: IResourceMethod<any, TramitesModel[]>;

  @ResourceAction({
    path: '/lista_tramites/st_activos'
  })
  obtenerListaTramitesSTActivos: IResourceMethod<any, TramitesModel[]>;

  @ResourceAction({
    path: '/na/tramite/{!id}'
  })
  obtenerTramite: IResourceMethod<{ id: any }, TramitesModel>;

  @ResourceAction({
    path: '/na/reporte_ruta'
  })
  obtenerTramitePorRuta: IResourceMethod<{ path: any }, TramitesModel>;

  @ResourceAction({
    path: '/tramite',
    method: ResourceRequestMethod.Post
  })
  insertarTramite: IResourceMethod<TramitesModel, any>;

  @ResourceAction({
    path: '/tramite/{!_id}',
    method: ResourceRequestMethod.Patch
  })
  actualizarTramite: IResourceMethod<TramitesModel, any>;

  @ResourceAction({
    path: '/lista_tramites/categoria/{!categoriaId}',
  })
  obtenerTramitesPorCategoria: IResourceMethod<{categoriaId: string}, TramitesModel[]>;

  @ResourceAction({
    path: '/categoria_activas',
  })
  obtenerCategoriasActivas: IResourceMethod<any, CategoriaModel[]>;

  @ResourceAction({
    path: '/categoria',
  })
  obtenerCategorias: IResourceMethod<any, CategoriaModel[]>;

  @ResourceAction({
    path: '/na/tramites?s={!s}',
  })
  obtenerTramitesPublic: IResourceMethod<{ s: any }, CategoriaModel[]>;
}
